/**
 * The keyCode property is deprecated. Use the key property instead.
 */

//This function doest used by now
export const aZ19keyCondition = (e: KeyboardEvent) => {
    const combinationKeys = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
    const code = Number(e.which);

    return (
        (code < 48 || code > 57) &&
        (code < 65 || code > 90) &&
        ((code > 37 && combinationKeys) || (code < 40 && combinationKeys))
    );
};

const keyCodes = {
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    SHIFT: 16,
    F1: 112,
    F2: 113,
    F5: 116,
    F6: 117,
    F8: 119,
    F11: 122,
    F12: 123,
    HOME: 36,
    END: 35,
    C: 67,
    I: 73,
    MoreInfo: 191,
    Backspace: 8,
    Minus: 189,
    Equal: 187
};

// use for not letters key
//use for event.key
export const keys = {
    TAB: 'Tab',
    ENTER: 'Enter',
    ESC: 'Escape',
    SPACE: ' ',
    PAGE_UP: 'PageUp',
    PAGE_DOWN: 'PageDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_UP: 'ArrowUp',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_DOWN: 'ArrowDown',
    SHIFT: 'Shift',
    F1: 'F1',
    F2: 'F2',
    F4: 'F4',
    F5: 'F5',
    F6: 'F6',
    F7: 'F7',
    F8: 'F8',
    F9: 'F9',
    F10: 'F10',
    F11: 'F11',
    F12: 'F12',
    HOME: 'Home',
    END: 'End',
    CTRL: 'Control',
    MINUS: '-',
    PLUS: '+',
    BACKSPACE: 'Backspace',
    DELETE: 'Delete',
    B: 'KeyB'
};

// use for letter keys not to be dependant on language and CapsLosck
export const codes = {
    B: 'KeyB',
    Z: 'KeyZ'
};

export const NAVIGATION_KEYS = [
    'ArrowUp',
    'ArrowDown',
    'PageUp',
    'PageDown',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight'
];

export default keyCodes;
